import { Box, keyframes, styled } from '@mui/material';

export const INBOX_CLEAR_STATE_TEST_ID = 'inbox-clear-state';

const zeroIn = keyframes`
  from { opacity: 0; transform: translateY(10px) scale(.96); }
`;

export const Stage = styled(Box, { name: 'InboxClearStateStage' })({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: '2.5rem 1.5rem',
  animation: `${zeroIn} .5s cubic-bezier(.2, .9, .3, 1.15)`,

  '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
});

export const Kicker = styled('div', { name: 'InboxClearStateKicker' })(({ theme }) => ({
  marginTop: '1.625rem',
  fontSize: '0.6875rem',
  fontWeight: 700,
  letterSpacing: '.18em',
  color: theme.palette.custom.OV.sys.primary,
}));

export const Heading = styled('h1', { name: 'InboxClearStateHeading' })(({ theme }) => ({
  margin: '0.625rem 0 0',
  fontSize: '1.625rem',
  fontWeight: 700,
  letterSpacing: '-.02em',
  color: theme.palette.custom.OV.sys.onBackground,
}));

export const Subtitle = styled('p', { name: 'InboxClearStateSubtitle' })(({ theme }) => ({
  margin: '0.625rem 0 0',
  fontSize: '0.84375rem',
  lineHeight: 1.6,
  maxWidth: '44ch',
  color: theme.palette.custom.OV.sys.onSurfaceVariant,
}));
